import React from 'react';
// import {steps} from '../../CreateSiteGuide/MenuSteps.js'
import connect from "react-redux/es/connect/connect";
import {Icon} from '@fluentui/react';

class Stepper extends React.Component {    

    render() {
        let fundaments = [];
        let steper = "";
        if(this.props.stepsA) {
            this.props.stepsA.map(x => fundaments.push({
                number: x.id, 
                current: x.id-1 === this.props.CurrentStep, 
                isValidated: x.validator()
            }));
            steper = fundaments.map((x, index) => {
                const stepperStyle = x.current ? "stepper2" : "stepper";
                return x.isValidated 
                    ? <div key={index} className={stepperStyle}><Icon iconName="CheckMark" /></div>
                    : <div key={index} className={stepperStyle}><span>{x.number}</span></div>
            })
        }
        return (
         <div>
             {steper}
         </div>
        );
    }
}

const mapStateToProps  = state => ({
    CurrentStep: state.wizard.currentStep
})

export default connect(mapStateToProps,null)(Stepper)







// WEBPACK FOOTER //
// ./src/components/CreateSite/CommonComponents/Stepper.js